import {alias, createModelSchema, list} from "serializr";
import {Schema} from "@/common/Schema";
import {BaseObject} from "@/common/BaseObject";
import {GuardTime} from "../../guard/GuardTime";
import {TriggerUtils} from "../../trigger/core/TriggerUtils";
import {SmartOfferKind} from "./SmartOfferKind";
import {SmartOfferButtonPlace} from "./SmartOfferButtonPlace";
import {SmartOfferBundleUtils} from "../bundle-core/SmartOfferBundleUtils";
import {RedactorUtils} from "@/modules/redactor/core/RedactorUtils";
import {ReminderBunch} from "@/modules/redactor/models/reminder/ReminderBunch";
import {SmartOfferSkin} from "./SmartOfferSkin";
import {MapGroupModel} from "@/modules/redactor/models/map/MapGroupModel";

export class SmartOffer extends BaseObject {

    constructor() {
        super();

        this._key = null;
        this._name = null;
        this._kind = SmartOfferKind.NONE;

        this._patchKey = null;

        this._buttonPlace = SmartOfferButtonPlace.NONE;
        this._buttonTimeout = 0;
        this._buttonPriority = 0;

        this._duration = 0;
        this._cooldown = 0;
        this._cooldownPassed = 0;
        this._cooldownOffset = 0;
        this._cooldownPassedOffset = 0;

        this._launchDelay = 0;
        this._launchDelayOffset = 0;

        this._quantity = 0;
        this._resetTime = 0;

        this._extendPending = 0;
        this._extendDuration = 0;

        this._autoOpenCooldown = 0;

        this._delayShow = 0;
        this._lastwave = 0;

        this._showOnLaunch = 0;

        this._talkActive = null;
        this._talkClosed = null;

        this._bundles = [];
        this._reminder = null;

        this._guardTime = new GuardTime();

        this._triggersAvailable = [];
        this._triggersComplete = [];

        this._remoteAssets = false;

        this._skins = [];

        this._mapGroup = null;
    }

    get key() {
        return this._key;
    }

    set key(value) {
        this._key = value;
    }

    get name() {
        return this._name;
    }

    set name(value) {
        this._name = value;
    }

    get kind() {
        return this._kind;
    }

    set kind(value) {
        this._kind = value;
    }

    get patchKey() {
        return this._patchKey;
    }

    set patchKey(value) {
        this._patchKey = value;
    }

    get buttonPlace() {
        return this._buttonPlace;
    }

    set buttonPlace(value) {
        this._buttonPlace = value;
    }

    get buttonTimeout() {
        return this._buttonTimeout;
    }

    set buttonTimeout(value) {
        this._buttonTimeout = value;
    }

    get buttonPriority() {
        return this._buttonPriority;
    }

    set buttonPriority(value) {
        this._buttonPriority = value;
    }

    get duration() {
        return this._duration;
    }

    set duration(value) {
        this._duration = value;
    }

    get cooldown() {
        return this._cooldown;
    }

    set cooldown(value) {
        this._cooldown = value;
    }

    get cooldownPassed() {
        return this._cooldownPassed;
    }

    set cooldownPassed(value) {
        this._cooldownPassed = value;
    }

    get cooldownOffset() {
        return this._cooldownOffset;
    }

    set cooldownOffset(value) {
        this._cooldownOffset = value;
    }

    get cooldownPassedOffset() {
        return this._cooldownPassedOffset;
    }

    set cooldownPassedOffset(value) {
        this._cooldownPassedOffset = value;
    }

    get launchDelay() {
        return this._launchDelay;
    }

    set launchDelay(value) {
        this._launchDelay = value;
    }

    get launchDelayOffset() {
        return this._launchDelayOffset;
    }

    set launchDelayOffset(value) {
        this._launchDelayOffset = value;
    }

    get quantity() {
        return this._quantity;
    }

    set quantity(value) {
        this._quantity = value;
    }

    get resetTime() {
        return this._resetTime;
    }

    set resetTime(value) {
        this._resetTime = value;
    }


    get extendPending() {
        return this._extendPending;
    }

    set extendPending(value) {
        this._extendPending = value;
    }

    get extendDuration() {
        return this._extendDuration;
    }

    set extendDuration(value) {
        this._extendDuration = value;
    }

    get autoOpenCooldown() {
        return this._autoOpenCooldown;
    }

    set autoOpenCooldown(value) {
        this._autoOpenCooldown = value;
    }

    get delayShow() {
        return this._delayShow;
    }

    set delayShow(value) {
        this._delayShow = value;
    }

    get lastwave() {
        return this._lastwave;
    }

    set lastwave(value) {
        this._lastwave = value;
    }

    get showOnLaunch() {
        return this._showOnLaunch;
    }

    set showOnLaunch(value) {
        this._showOnLaunch = value;
    }

    get talkActive() {
        return this._talkActive;
    }

    set talkActive(value) {
        this._talkActive = value;
    }

    get talkClosed() {
        return this._talkClosed;
    }

    set talkClosed(value) {
        this._talkClosed = value;
    }

    get bundles() {
        return this._bundles;
    }

    set bundles(value) {
        this._bundles = value;
    }

    get reminder() {
        return this._reminder;
    }

    set reminder(value) {
        this._reminder = value;
    }

    get guardTime() {
        return this._guardTime;
    }

    set guardTime(value) {
        this._guardTime = value;
    }

    get mapGroup() {
        return this._mapGroup;
    }

    set mapGroup(value) {
        this._mapGroup = value;
    }

    get triggersAvailable() {
        return this._triggersAvailable;
    }

    set triggersAvailable(value) {
        this._triggersAvailable = value;
    }

    get triggersComplete() {
        return this._triggersComplete;
    }

    set triggersComplete(value) {
        this._triggersComplete = value;
    }

    get remoteAssets() {
        return this._remoteAssets;
    }

    set remoteAssets(value) {
        this._remoteAssets = value;
    }

    get skins() {
        return this._skins;
    }

    set skins(value) {
        this._skins = value;
    }

    valid() {

        if (!SmartOfferKind.is(this.kind)) {
            return false;
        } else if (SmartOfferKind.MASTER.equal(this.kind)) {

            if (this.bundles && this.bundles.length > 0) {
                return false;
            }

        } else if (SmartOfferKind.EXPEDITION.equal(this.kind)) {

            if (this.bundles && this.bundles.length > 0) {
                return false;
            }

        } else {

            if (!this.bundles || this.bundles.length === 0) {
                return false;
            }

            if (this.bundles.some(v => !v || !v.valid())) {
                return false;
            }
        }

        if (this.bundles && this.bundles.length > 1) {
            for (let i = 1; i < this.bundles.length; i++) {
                if (!this.bundles[0].kind.equal(this.bundles[i].kind)) {
                    return false;
                }
            }
        }

        if (!Number.isInteger(this.buttonTimeout) || this.buttonTimeout < 0) {
            return false;
        }

        if (!Number.isInteger(this.buttonPriority) || this.buttonPriority < 0) {
            return false;
        }

        if (!Number.isInteger(this.duration) || this.duration < -1) {
            return false;
        }

        if (!Number.isInteger(this.cooldown) || this.cooldown < 0) {
            return false;
        }

        if (!Number.isInteger(this.cooldownPassed) || this.cooldownPassed < 0) {
            return false;
        }

        if (!Number.isInteger(this.cooldownOffset) || this.cooldownOffset < 0) {
            return false;
        }

        if (!Number.isInteger(this.cooldownPassedOffset) || this.cooldownPassedOffset < 0) {
            return false;
        }

        if (!Number.isInteger(this.launchDelay) || this.launchDelay < 0) {
            return false;
        }

        if (!Number.isInteger(this.launchDelayOffset) || this.launchDelayOffset < 0) {
            return false;
        }

        if (!Number.isInteger(this.quantity) || this.quantity < 0) {
            return false;
        }

        if (!Number.isInteger(this.resetTime) || this.resetTime < 0) {
            return false;
        }

        if (!Number.isInteger(this.autoOpenCooldown) || this.autoOpenCooldown < 0) {
            return false;
        }

        if (Number.isNaN(this.delayShow) || this.delayShow < 0) {
            return false;
        }

        if (Number.isNaN(this.lastwave) || this.lastwave < 0) {
            return false;
        }

        if (!Number.isInteger(this.extendDuration) || this.extendDuration < -1) {
            return false;
        }

        if (!Number.isInteger(this.extendPending) || (this.extendDuration > 0 && this.extendPending < 0)) {
            return false;
        }

        if (this.talkActive && !RedactorUtils.getTalk(this.talkActive)) {
            return false;
        }

        if (this.talkClosed && !RedactorUtils.getTalk(this.talkClosed)) {
            return false;
        }

        if (this.reminder && !this.reminder.valid()) {
            return false;
        }

        if (this.guardTime && !this.guardTime.valid()) {
            return false;
        }

        if (this.triggersAvailable.some(v => !v || !v.valid())) {
            return false;
        }

        if (this.triggersComplete.some(v => !v || !v.valid())) {
            return false;
        }

        if (this.skins && this.skins.length > 0) {
            // console.log(this.skins);

            if (this.skins.filter((skin) => skin.default === true).length != 1) {
                console.log("SmartOffer invalid isKeyDuplicate");
                return false;
            }

            var skinsKey = this.skins.map(function (skin) {
                return skin.key;
            });
            // console.log(skinsKey);
            var isKeyDuplicate = skinsKey.some(function (item, idx) {
                return skinsKey.indexOf(item) != idx
            });

            if (isKeyDuplicate) {
                console.log("SmartOffer invalid isKeyDuplicate");
                return false;
            }

            if (this.skins.some(skin => !skin.default && skin.duration == 0)) {
                return false;
            }

            const anyIntervalsIntersect = (intervals) =>
                intervals
                    .sort((a, b) => a[0] - b[0])
                    .some((_, i, arr) => i > 0 && arr[i - 1][1] >= arr[i][0]);

            const buildTimeIntervals = (skins) => {
                let timeIntervals = []
                skins.forEach(function (skin) {
                    timeIntervals.push([skin.started, skin.started + skin.duration]);
                });
                return timeIntervals;
            }

            if (anyIntervalsIntersect(buildTimeIntervals(this.skins))) {
                console.log("SmartOffer invalid anyIntervalsIntersect");
                return false;
            }
        }

        if (this.mapGroup && (MapGroupModel.isGlobal(this.mapGroup) || MapGroupModel.isMain(this.mapGroup))) {
            return false;
        }

        return true;
    }

    copy() {
        let value = super.copy();
        value._enabled = false;
        return value;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new SmartOffer());
        } else if (target instanceof SmartOffer) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(SmartOffer, {
    _key: alias("key", Schema.primitive()),
    _name: alias("name", Schema.primitive()),
    _kind: alias("kind", SmartOfferKind.schema()),

     _patchKey: alias("patch_key", Schema.primitive()),

    _buttonPlace: alias("button_place", SmartOfferButtonPlace.schema()),
    _buttonTimeout: alias("button_timeout", Schema.primitive()),
    _buttonPriority: alias("priority", Schema.primitive()),

    _duration: alias("duration", Schema.primitive()),
    _cooldown: alias("cooldown", Schema.primitive()),
    _cooldownPassed: alias("cooldown_passed", Schema.primitive()),

    _cooldownOffset: alias("cooldown_offset", Schema.primitive()),
    _cooldownPassedOffset: alias("cooldown_passed_offset", Schema.primitive()),

    _launchDelay: alias("launch_delay", Schema.primitive()),
    _launchDelayOffset: alias("launch_delay_offset", Schema.primitive()),

    _quantity: alias("quantity", Schema.primitive()),
    _resetTime: alias("resettime", Schema.primitive()),

    _extendPending: alias("extratime_pending", Schema.primitive()),
    _extendDuration: alias("extratime", Schema.primitive()),

    _autoOpenCooldown: alias("auto_open_cooldown", Schema.primitive()),

    _delayShow: alias("delay_show", Schema.primitive()),
    _lastwave: alias("lastwave", Schema.primitive()),

    _showOnLaunch: alias("show_launch", Schema.primitive()),

    _talkActive: alias("talk_active", Schema.primitive()),
    _talkClosed: alias("talk_closed", Schema.primitive()),

    _bundles: alias("bundles", SmartOfferBundleUtils.schema()),
    _reminder: alias("reminder_bunch", ReminderBunch.schema()),

    _guardTime: alias("guard_time", GuardTime.schema()),

    _triggersAvailable: alias("triggers_available", TriggerUtils.schema()),
    _triggersComplete: alias("triggers_complete", TriggerUtils.schema()),

    _remoteAssets: alias("remote_assets", Schema.primitive()),

    _skins: alias("skins", list(SmartOfferSkin.schema())),

    _mapGroup: alias("map_group", MapGroupModel.schema()),
});
